import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from 'components/shared/AntComponent';
import { Button, Select } from 'components/shared/FormComponent';
import { LoadingOutlined, SyncOutlined } from 'components/shared/AntIcons';
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';
import { getCandidDashboard, getDashboard, getDashboardInfo } from 'services/store/actions/dashboardAction';
import InterviewIcon from 'assets/icons/interview-user.svg';
import InternBatchIcon from 'assets/icons/intern-batch-icon.svg';
import InternProjIcon from 'assets/icons/intern-project-icon.svg';
import InternIcon from 'assets/icons/graduate-icon.svg';
import { dashboardExamList, getExam } from 'services/store/actions/examAction';
import dayjs from 'dayjs';

const Dashboard: React.FC = () => {
    const dispatch = useDispatch();
    const { dashInfo, loading2, loading, dashCandidInfo, loading1, dashboardInfo } = useSelector((state: any) => state.dashboard);
    const { examData, loading: examLoading, success8, error8, loading14, dashExamList } = useSelector((state: any) => state.exam);
    const examList = dashboardInfo?.upcoming_exams || [];
    const examCount = dashboardInfo?.monthly_exam_report?.exam_counts.filter((value: any) => value !== 0).length;
    const [exam, setExam] = useState('');
    const colors = ['#5ca8e6', '#f7b950', '#8ad15e', '#ba80d0'];

    const examOptions: any = !loading14 ? dashExamList?.data?.map((acc: any) => {
        return {
            label: acc?.exam_title,
            value: acc.id?.toString(),
            key: acc.id,
        };
    }) : [];
    // const {use}
    function getDashboardDetails(exam: any) {
        const inputJson = {
            examid: Number(exam)
        }
        dispatch(getDashboard(inputJson) as any);
    }
    const getExamDetails = () => {
        const inputJson = {
            "InputJson": {
                "examid": 0
            },
            "DataFinder": {
                pagesize: 10000,
                currentpage: 1,
                sortbycolumn: '',
                sortby: 'asc',
                searchdata: '',
            }
        };
        dispatch(getExam(inputJson) as any);
    };
    // useEffect(() => {
    //     getDashboardDetails();
    // }, []);

    const statItems = [
        { id: 1, cardName: 'Registered #', value: dashInfo?.data?.total_register || 0, icon: InterviewIcon, color: 'stat-green', },
        { id: 2, cardName: 'Attended #', value: dashInfo?.data?.total_total_present || 0, icon: InternBatchIcon, color: 'stat-purple', },
        { id: 3, cardName: 'Unattended #', value: dashInfo?.data?.total_total_absent || 0, icon: InternIcon, color: 'stat-blue', },
        { id: 4, cardName: 'Failed ', value: dashInfo?.data?.total_total_failed || 0, icon: InternProjIcon, color: 'stat-orange' }
    ];

    const getExamListInfo = () => {
        const inputJson = {
            "is_active": true,
            "created_by": "asc"
        }
        dispatch(dashboardExamList(inputJson) as any);
    }
    useEffect(() => {
        dispatch(getCandidDashboard() as any);
    }, []);

    useEffect(() => {
        dispatch(getDashboardInfo() as any);
    }, []);

    useEffect(() => {
        getExamListInfo();
    }, []);

    const series = [{
        name: "Exam",
        data: dashboardInfo?.monthly_exam_report?.exam_counts || []
    }];
    const options: ApexOptions = {
        colors: ["#F7941E"],
        chart: {
            height: 350,
            type: 'bar',

            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false // Disable zooming
            },
        },

        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 1.5,
            curve: 'smooth',

        },
        title: {
            text: '',
            align: 'left'
        },
        grid: {
            show: false,
            xaxis: {
                lines: {
                    show: false  //or just here to disable only x axis grids
                }
            },
            // row: {
            //     colors: ['#fff'], // takes an array which will be repeated on columns
            //     opacity: 0.5
            // },
        },
        yaxis: {
            labels: {
                show: false,
            },
        },
        xaxis: {
            labels: {
                show: false,
            },
            // axisBorder: {
            //     show: false
            // },
            categories: dashboardInfo?.monthly_exam_report?.months || [],
        }
    };
    const series1 = [
        {
            name: 'Applicants',
            type: 'area',
            data: dashCandidInfo?.candidates_analysis?.interview_candidates || []
        },];

    const options1: ApexOptions = {
        // colors: ["#696cff", "#03c3ec","#67dbf3"],
        // colors: ["#ffa50094", "#acec85", "#696cffad",],
        chart: {
            type: 'line',
            height: 350,
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false // Disable zooming
            },
        },

        legend: {
            show: true,
            position: 'top',
            // t: 'right',
            horizontalAlign: 'right',
            fontFamily: 'Lato',
            // markers: {
            //     width: 15,
            //     height: 3,
            // },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: 'smooth',
            width: 2,
        },
        grid: {
            show: false,
            xaxis: {
                lines: {
                    show: false  //or just here to disable only x axis grids
                }
            },
        },
        colors: ['#ffa902', '#7a6efe', '#24a8fa'],
        xaxis: {
            // type: 'date',
            tickAmount: 4,
            categories: dashCandidInfo?.candidates_analysis?.dates || [],
            labels: {
                rotate: 0,  // Remove rotation by setting it to 0
            },
        },

        tooltip: {
            x: {
                format: 'MM/dd/yy ',
                // max: 4,
            },
        },
    };

    useEffect(() => {
        if (dashExamList?.data) {
            setExam(dashExamList?.data?.[0]?.id?.toString());
            getDashboardDetails(dashExamList?.data?.[0]?.id);
        }
    }, [dashExamList]);

    const handleExamChange = (e: any) => {
        setExam(e);
        getDashboardDetails(e)
    }

    return (
        <div>
            <div className='row mx-0 mt-2 mb-3 pt-3'>
                <div className="col-md-9 ps-0 ">
                    <div className='d-flex w-100 mb-2 page-header '>
                        <div className='ps-3 mb-3'>
                            <h5 className="text-dark fs-20 fw-bold col-auto my-auto">Dashboard</h5>

                            <div className="d-flex mt-2">
                                <p className="my-auto">Welcome back! Here&apos;s an overview of your exam.</p>

                            </div>
                        </div>
                        <div className='col my-auto d-flex'>
                            <div className='col-md-3 ms-auto dashboard-select text-end'>
                                <Select options={examOptions} showSearch
                                    defaultValue={exam}
                                    loading={examLoading}
                                    value={exam}
                                    onChange={handleExamChange}
                                    popupMatchSelectWidth={false}
                                    // loading={examLoading}
                                    // dropdownStyle={{ minWidth: 200 }}
                                    className='w-auto'
                                    notFoundContent={
                                        <div className="text-center p-4">
                                            {examLoading ? (
                                                <span>
                                                    <LoadingOutlined />
                                                    Loading...
                                                </span>
                                            ) : (
                                                <span>No exam found</span>
                                            )}
                                        </div>
                                    }
                                    filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                                />
                            </div>
                            <div className="ms-2">
                                <Button type="primary" icon={loading2 ? <SyncOutlined spin /> : <SyncOutlined />} className="header-btn rounded-circle" onClick={() => getDashboardDetails(exam)}>Check for updates</Button>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="row mx-0 stat-cards-box">
                            {statItems?.map((item: any, index: number) => {
                                return (
                                    <div key={index} className={`stat-card ${item.color} rounded col-md-6 mb-3 pe-0 `}>
                                        <div className='bg-white p-2 text-center shadow-sm rounded d-flex'>
                                            <div className={`bg-img ms-2 mt-2`}>
                                                <img src={`${item.icon}`} height={item.id == 3 || item.id == 4 || item.id == 5 ? 37 : 35} />
                                            </div>
                                            <div className='col text-center my-auto'>
                                                <div className=" mb-0 ps-2 text-gray fs-16 ">{item.cardName}</div>
                                                <div className='text-darkgray regular-font ps-2 fs-3 '>{loading2 || loading14 ? <Skeleton.Button active /> : item.value}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="col-md-6 ps-3">
                            <div className='bg-white stat-cards-box rounded shadow-sm mb-3 d-flex'>
                                <div className='ps-3 pt-3 col-md-4 stat-card'>
                                    <h5 className='text-secondary regular-font'>Exam Report</h5>
                                    <p className='bg-orange mb-2 mt-4 ps-0'>YEAR 2025</p>
                                    <div className='text-darkgray regular-font ps-0 fs-2 '>{loading1 ? <Skeleton.Button active className="pb-2" /> : examCount}</div>
                                </div>
                                <div className='ms-auto col'>
                                    {loading1 ? <Skeleton active className="mt-3"></Skeleton> :
                                        <Chart options={options} series={series} type="bar" width="100%" height="170vh" />}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='bg-white p-3 ms-2 rounded shadow-sm'>
                        <h5 className='text-dark regular-font fs-18'>Applicant Analysis</h5>
                        {loading ? <Skeleton active /> :
                            <Chart options={options1} series={series1} type="area" width="100%" height="398vh" />}
                    </div>
                    <div>
                    </div>
                </div>
                <div className='col-md-3 px-2 pt-0 h-100'>

                    <div className='mx-0 px-0 pt-0'>
                        <div className='bg-white p-3 rounded shadow-sm ms-0'>
                            <div className='d-flex mb-3'>
                                <h5 className='regular-font text-dark fs-18'>Upcoming Exam</h5>
                                {examList?.length > 6 ? <div className='ms-auto col-auto'>
                                    <p className='text-blue mb-0 regular-font pointer'>See all</p>
                                </div> : ""}
                            </div>
                            <div className='control-height'>
                                {loading1 ? <Skeleton active /> : <>
                                    {examList?.length == 0 ? <div className='bg-light d-flex align-items-center justify-content-center h-100'>
                                        <p className="text-gray">No upcoming exams found</p>
                                    </div> : <>
                                        {examList?.map((item: any, index: any) => {
                                            return (
                                                <div key={index} className={'mb-3 p-3 shadow-sm border-top border-end rounded bg-light'} style={{ borderLeft: `5px solid ${colors[index % colors.length]}`, }}>
                                                    <div className="d-flex">
                                                        <h6 className='regular-font mb-0'>{item.exam_title}</h6>
                                                        <h6 className='ms-auto regular-font'>{item.examcode}</h6>
                                                    </div>
                                                    <p className='text-gray mb-1'>{item.description}</p>
                                                    <small className='text-gray fs-13 fw-600'>Date: {item.exam_date ? dayjs(new Date(item.exam_date)).format('MM/DD/YYYY') : '--'}</small>
                                                    <small className='text-gray fs-13 fw-600 ps-5'>{item.start_time}</small>
                                                </div>
                                            )
                                        })}</>}</>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

};

export default Dashboard;
